import _classCallCheck from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Point = function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
};